import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { MarketProvider } from './lib/market-context';
import { TraderProvider } from './lib/trader-context';
import { PremiumProvider } from './lib/premium-context';
import App from './App';
import './styles.css';
import './detail.css';
import './profile-content.css';
import './branding.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><BrowserRouter><AuthProvider><MarketProvider><TraderProvider><PremiumProvider><App /></PremiumProvider></TraderProvider></MarketProvider></AuthProvider></BrowserRouter></React.StrictMode>);
